export default __webpack_public_path__ + "static/invoice-90a5a2b7cd0aaad7063511c2ff300665.png";